query MobileScoreData(
	$days: Int!
	$customFieldsFilter: ConditionStringArray
	$customFieldsFilterExcludes: ConditionStringArray
	$mfaOsFilter: ConditionStringArray
	$mfaAppIdFilter: ConditionStringArray
	$msdkOsFilter: ConditionString
	$msdkAppFilter: ConditionString
) {
	mfaDailyIssues: mfa_session_runs(
		run_updated_at_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $mfaOsFilter
		app_id_eq_any_item_for_any_value: $mfaAppIdFilter
	) {
		run_updated_at_max
	}
	msdkDailyIssues: msdk_report_runs(
		run_time_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $msdkOsFilter
		app_eq: $msdkAppFilter
	) {
		run_time_max
	}
}
